<template>
  <VBtn flat class="danger" :disabled="disabled" @click="showDeleteModal">
    <slot><i class="fr fr-close" /></slot>
  </VBtn>
</template>

<script setup lang="ts">
  // Components
  import VBtn from '~/misc/v-btn';

  const props = defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
    itemDescription: {
      type: String,
      default: 'item',
    },
  });

  const DeleteModal = defineAsyncComponent(
    () => import('~/misc/resource/delete/modal/DeleteModal.vue')
  );

  const { show: showModal } = useModal();

  const emit = defineEmits<{
    (e: 'confirm'): void;
  }>();

  const showDeleteModal = () =>
    showModal(DeleteModal, {
      confirmedCallback: () => emit('confirm'),
      itemDescription: props.itemDescription,
    });
</script>
